// services/rest-api-sms/lib/tasks/tasks.js
import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/tasks' // or the actual base path for tasks

export const update = async (taskId, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${taskId}`,
    data,
  })
  return response
}

export const remove = async (taskId) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}/${taskId}`,
  })
  return response
}